module.exports = __webpack_public_path__ + "img/united_kingdom.601073f.webp";